import Common from './common/common.json';
import Layout from './common/layout.json';
import BeneficiariesDataForm from './components/BeneficiariesDataForm/beneficiariesDataForm.json';
import BeneficiariesModal from './components/BeneficiariesModal/beneficiariesModal.json';
import CoverageModal from './components/CoverageModal/coverageModal.json';
import DateInput from './components/DateInput/DateInput.json';
import DeleteModal from './components/DeleteModal/DeleteModal.json';
import DevAlert from './components/DevStageAlert/dev_stage_alert.json';
import FamilyDataForm from './components/FamilyDataForm/familyDataForm.json';
import FamilyModal from './components/FamilyModal/familyModal.json';
import IconModal from './components/IconModal/iconModal.json';
import IdentityValidationModal from './components/IdentityValidationModal/IdentityValidationModal.json';
import LegalHeirsModal from './components/LegalHeirsModal/legalHeirsModal.json';
import PaymentMethod from './components/PaymentMethod/paymentMethod.json';
import PlanCard from './components/PlanCard/planCard.json';
import PlanFullModal from './components/PlanFullModal/planFullModal.json';
import PlanSummary from './components/PlanSummary/planSummary.json';
import QuoteCard from './components/QuoteCard/quoteCard.json';
import SharePersonalDataModal from './components/SharePersonalDataModal/sharePersonalDataModal.json';
import ShouldKnowSection from './components/ShouldKnowSection/shouldKnowSection.json';
import SuggestedProducts from './components/SuggestedProducts/SuggestedProducts.json';
import WhyDataCorrectModal from './components/WhyDataCorrectModal/WhyDataCorrectModal.json';
import UseAgeToHire from './hooks/useAgeToHire.json';
import LayoutWithFooter from './layouts/LayoutWithFooter.json';
import BeneficiariesData from './templates/beneficiariesData.json';
import CheckoutData from './templates/checkoutData.json';
import CompensationData from './templates/compensationData.json';
import ContactData from './templates/contactData.json';
import ContactDataForm from './templates/contactDataForm.json';
import ContinueFlowTemplate from './templates/continue_flow.json';
import ErrorAssistedTemplate from './templates/error_assisted.json';
import ErrorIdentity from './templates/errorIdentity.json';
import ErrorPayment from './templates/errorPayment.json';
import FamilyData from './templates/familyData.json';
import LoremIpsum from './templates/loremIpsum.json';
import PersonalData from './templates/personalData.json';
import PersonalDataForm from './templates/personalDataForm.json';
import Quoter from './templates/quoter.json';
import SuccessAssistedTemplate from './templates/success_assisted.json';
import SuccessTemplate from './templates/successTemplate.json';
import TokuPaymentData from './templates/tokuPaymentData.json';

const es = {
  ...LoremIpsum,
  ...TokuPaymentData,
  ...Quoter,
  ...QuoteCard,
  ...PlanFullModal,
  ...PlanCard,
  ...PersonalData,
  ...PersonalDataForm,
  ...PlanSummary,
  ...Common,
  ...Layout,
  ...UseAgeToHire,
  ...ContactData,
  ...ContactDataForm,
  ...FamilyData,
  ...FamilyDataForm,
  ...FamilyModal,
  ...CheckoutData,
  ...PaymentMethod,
  ...SharePersonalDataModal,
  ...IdentityValidationModal,
  ...ErrorIdentity,
  ...ErrorPayment,
  ...DeleteModal,
  ...ShouldKnowSection,
  ...IconModal,
  ...CoverageModal,
  ...BeneficiariesModal,
  ...WhyDataCorrectModal,
  ...DateInput,
  ...LayoutWithFooter,
  ...SuggestedProducts,
  ...SuccessTemplate,
  ...CompensationData,
  ...LegalHeirsModal,
  ...BeneficiariesData,
  ...BeneficiariesDataForm,
  ...DevAlert,
  ...ContinueFlowTemplate,
  ...SuccessAssistedTemplate,
  ...ErrorAssistedTemplate,
};

export default es;
